import { useMemo } from 'react';
import { BUDGET_YEAR_FIELD } from 'routes/BudgetModule/config/constants';
import { ResourceSoftwareIdField } from 'routes/BudgetModule/config/types';
import { ProjectionVentilation } from '../helpers/types';

/**
 * Returns the list of all ProjectionDetailsFields that mark the unicity of a projection detail.
 * (Used mainly for ProjectionGrid to keep track of his rows)
 */
export const useBuildUnicityDimensions = (
    resourceSoftwareIdField: ResourceSoftwareIdField,
    projectionBy: ProjectionVentilation.SoftwareIds[],
): { unicityDimensions: ProjectionVentilation.SoftwareIds[] } => {
    const unicityDimensions = useMemo(
        () => [BUDGET_YEAR_FIELD, resourceSoftwareIdField, ...projectionBy],
        [projectionBy, resourceSoftwareIdField],
    ) as ProjectionVentilation.SoftwareIds[];
    return { unicityDimensions };
};
